import React, { useState } from "react";
import useGallery from "../../custom-hooks/useGallery";
import useTags from "../../custom-hooks/useTags";
import { Col, Image, Layout, Row, Tag, Typography } from "antd";
import Spinner from "../Spinner";
import "./Gallery.less";

const { Content } = Layout;
const { Text } = Typography;

const Gallery = () => {
  const [images, isLoading] = useGallery();
  const tags = useTags();
  const [selectedTags, setSelectedTags] = useState([]);
  const handleChange = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter((t) => t !== tag);
    console.log(nextSelectedTags);
    setSelectedTags(nextSelectedTags);
  };

  if (isLoading) {
    return <Spinner />;
  }
  const filteredImages = selectedTags.length
    ? images.filter((image) =>
        image.metadata.tags.some((tag) => selectedTags.includes(tag.sys.id))
      )
    : images;

  return (
    <Content style={{ padding: "24px" }}>
      <Row style={{ marginBottom: "12px" }}>
        <Text>Tags:</Text>
        {tags.map((tag) => (
          <Tag.CheckableTag
            key={tag}
            bordered={true}
            checked={selectedTags.includes(tag)}
            onChange={(checked) => handleChange(tag, checked)}
          >
            {tag}
          </Tag.CheckableTag>
        ))}
      </Row>
      <Row gutter={[16, 16]}>
        {filteredImages.map((obj, index) => (
          <Col
            style={{ alignContent: "center" }}
            key={index}
            xs={24}
            sm={12}
            md={8}
            lg={6}
          >
            <Image
              alt={obj.fields.image.title}
              src={obj.fields.image.fields.file.url}
            />
          </Col>
        ))}
      </Row>
    </Content>
  );
};

export default Gallery;
